<template>
  <div class="main">
    <div>
      <div class="pd20 fw600">学生信息</div>
      <div class="pd20">
        <el-form :model="form" ref="form" :rules="rules" label-width="60px">
          <el-form-item prop="phone" label="电话">
            <el-input v-model="form.phone" show-word-limit maxlength="11" placeholder="电话"/>
          </el-form-item>
        </el-form>
        <div style="margin-top: 10px;">
          <el-button type="primary" :loading="loadingBtn" size="mini" @click="submit">确 定</el-button>
        </div>
      </div>
    </div>
    <el-divider/>
  </div>
</template>

<script>
  import {ref, reactive} from "@vue/composition-api";

  export default {
    setup() {
      // 定义响应式数据 ref对象
      const isEdit = ref(false)
      const loadingBtn = ref(false)
      const form = reactive({
        phone: '13545124141'
      })

      return {isEdit, form, loadingBtn}
    },
    components: {},
    data() {
      var validatePhone = (rule, value, callback) => {
        if (!/^1[3456789]\d{9}$/.test(value)) {
          callback(new Error("请输入正确的手机号！"));
        } else {
          callback();
        }
      };
      return {
        rules: {
          phone: [
            {required: true, message: "请填写手机号", trigger: "blur"},
            {validator: validatePhone, trigger: "blur"}
          ]
        },
      };
    },
    mounted() {
    },
    methods: {
      submit() {
        this.$refs['form'].validate(async valid => {
          try {
            if (valid) {
              this.loadingBtn = true;
              console.log(this.form);
              // await this.$HTTP.ApiCollegeAdmin.collegeAdd4StaffGET(param);
              this.$message.success("操作成功！");
              this.loadingBtn = false;
            } else {
              return false;
            }
          } catch (error) {
            this.loadingBtn = false;
          }
        });
      },
    },
  };
</script>

<style lang="less" scoped>
  .main {
    padding-top: 10px;
    height: calc(100vh);
    background-color: #ffffff;

    .pd20 {
      padding: 0 20px;
    }

    .fs14 {
      font-size: 14px;
    }

    .fw600 {
      font-weight: 600;
      margin-bottom: 10px;
    }
  }
</style>
